
"use strict";

class SceneCollection {

	constructor() {

		this.scenes = [];
		this.activeScene = null;
	}

	getActiveScene() {

		return this.activeScene;
	}

	getActiveSceneName() {

		return this.activeScene.name;
	}

	setActiveScene(name) {

		if(!this.isValidScene(name)) {
			return false;
		}

		this.activeScene = this.getSceneByName(name);
		return true;
	}

	addScene(scene) {

		this.scenes.push(scene);
	}

	getAllScenes() {

		return this.scenes;
	}

	getDefaultScene() {

		for (let i=0; i<this.scenes.length; i++) {
			if(this.scenes[i].isDefault) {
				return this.scenes[i];
			}
		}

		return null;
	}

	getSceneByName(name) {

		for (let i=0; i<this.scenes.length; i++) {
			if(this.scenes[i].name.toLowerCase() === name.toLowerCase()) {
				return this.scenes[i];
			}
		}

		return null;
	}

	isValidScene(name) {

		for (let i=0; i<this.scenes.length; i++) {

			if(this.scenes[i].name.toLowerCase() === name.toLowerCase()) {
				return true;
			}
		}

		return false;
	}
}


class Scene {

	constructor(name, isDefault, leftEyeImage, rightEyeImage, headline, description, previewImage, poiData, oPosX, oPosY, oImage, portalData, startLat=0, startLon=0) {

		this.name = name;
		this.isDefault = isDefault;
		this.leftEyeImage = leftEyeImage;
		this.rightEyeImage = rightEyeImage;
		this.headline = headline;
		this.description = description;
		this.previewImage = previewImage;
		this.poiData = poiData;
		this.overviewPosX = oPosX;
		this.overviewPosY = oPosY;
		this.overviewImage = oImage;
		this.portalData = portalData;
		this.startLat = startLat;
		this.startLon = startLon;
	}
}
